"use client";

import type { ReactNode } from "react";
import { EmptyState } from "@dionatanbig2be/big2be-ui";
import { OrderCardView } from "./OrderCardView";
import type { OrderCard } from "../../types/orders";

interface OrdersSectionProps {
    title: string;
    orders: OrderCard[];
    onSelectOrder: (order: OrderCard) => void;
    /** Ícone e texto do estado vazio da seção. */
    emptyIcon: ReactNode;
    emptyTitle: string;
}

/**
 * Seção de pedidos: cabeçalho com contagem + grid de cards. O corte de
 * colunas é por CONTAINER (`@[44rem]` — o painel da conta é `@container`):
 * no mobile/accordion não há container e a base de 1 coluna prevalece.
 */
export function OrdersSection({ title, orders, onSelectOrder, emptyIcon, emptyTitle }: OrdersSectionProps) {
    return (
        <section aria-label={title}>
            <div className="mb-3 flex items-center gap-2.5">
                <h3 className="text-[0.85rem] font-bold uppercase tracking-[0.05em] text-base-content/45">
                    {title}
                </h3>
                <span className="inline-flex h-[1.4rem] min-w-[1.4rem] items-center justify-center rounded-full bg-base-content/10 px-[0.4rem] text-[0.72rem] font-extrabold text-base-content/60">
                    {orders.length}
                </span>
            </div>

            {orders.length === 0 ? (
                <EmptyState
                    className="rounded-2xl border border-dashed border-base-300/80 px-4 py-8"
                    icon={emptyIcon}
                    title={emptyTitle}
                />
            ) : (
                <div className="grid grid-cols-1 gap-4 @[44rem]:grid-cols-2">
                    {orders.map((order) => (
                        <OrderCardView key={order.id} order={order} onSelect={onSelectOrder} />
                    ))}
                </div>
            )}
        </section>
    );
}
